import { create } from 'zustand';

import type { IRankDetail } from '@/service/visualization';
import { getAboutMe, getKeywordList, getRankDetail, getShadeDetail } from '@/service/visualization';
import type { Biog, Introduce, RelateQuery, ShadeDetail } from '@/types/visualization';

interface TodoManageStore {
  shadeDetail: ShadeDetail;
  rankDetail: IRankDetail;
  refreshRankDetail: () => void;
  updateShadeDetail: (data: RelateQuery, refresh?: boolean) => Promise<void>;
  paginationRef: React.MutableRefObject<{ pageNo: number; pageSize: number }>;
  keywords: Biog[];
  introduce: Introduce;
  updateKeyword: () => void;
  detailLoading: boolean;
  loadingKeyWord: boolean;
  aboutMe: string;
  updateAboutMe: (data?: string) => void;
}
const useBiogStore = create<TodoManageStore>()((set, get) => ({
  shadeDetail: { list: [], total: 0 },
  rankDetail: { dayNum: 0, memoryCount: 0 },
  paginationRef: { current: { pageNo: 1, pageSize: 20 } },
  detailLoading: false,
  keywords: [],
  loadingKeyWord: false,
  aboutMe: '',
  introduce: {},
  updateAboutMe: (data) => {
    if (!data) {
      getAboutMe()
        .then((res) => {
          set({
            aboutMe: res.data.data.selfIntroduction
          });
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      set({
        aboutMe: data
      });
    }
  },
  refreshRankDetail: () => {
    getRankDetail().then((res) => {
      if (res.data.code === 0) {
        const data = res.data.data;

        set({
          rankDetail: data
        });
      }
    });
  },
  updateShadeDetail: (data, refresh = true) => {
    if (refresh) {
      set({ shadeDetail: { list: [], total: 0 } });
      set({ paginationRef: { current: { pageNo: 1, pageSize: 20 } } });
      set({
        detailLoading: true
      });
    } else {
      const pageNo = get().paginationRef.current.pageNo;

      set({ paginationRef: { current: { pageNo: pageNo + 1, pageSize: 20 } } });
    }

    return getShadeDetail({ ...data, ...get().paginationRef.current })
      .then((res) => {
        if (res.data.code === 0) {
          const _data = res.data.data;

          if (refresh) {
            set({
              shadeDetail: _data
            });
          } else {
            const _list = get().shadeDetail.list || [];

            set({
              shadeDetail: {
                ...get().shadeDetail,
                list: [..._list, ...(_data.list || [])],
                total: _data.total
              }
            });
          }
        }
      })
      .catch((err) => {
        throw err;
      })
      .finally(() => {
        set({
          detailLoading: false
        });
      });
  },

  updateKeyword: () => {
    const keywords = get().keywords;

    if (Object.keys(keywords).length === 0) {
      set({
        loadingKeyWord: true
      });
    }

    getKeywordList()
      .then((res) => {
        if (res.data.code === 0) {
          const data = res.data.data;
          const biogShades = data.biogShades;
          const biogWord = data.biogWord;
          const biog = biogWord?.map((word) => {
            const content = biogShades?.filter((item) => item.id === word.id)[0].content;

            return {
              id: word.id,
              icon: word.icon,
              weight: word.weight,
              word: word.word,
              content: content
            };
          });
          const introduce: Introduce = {
            memoryNum: data.memoryNum,
            title: data.title,
            memoryTips: data.memoryTips,
            userName: data.userName
          };

          set({
            keywords: biog || [],
            introduce: introduce
          });
        }
      })
      .catch((err) => {
        throw err;
      })
      .finally(() => {
        set({
          loadingKeyWord: false
        });
      });
  }
}));

export default useBiogStore;
